import React, { Component } from 'react'
import styled from 'react-emotion'
import { VideoPlayer } from 'react-video-player'
import ClipsContainer from './ClipsContainer'
import { Container, spacer, mediaDn, typography, fontWeight } from 'stylist'
import TransitionGroup from 'components/animation/TransitionGroup'
import { FadeIn } from 'components/animation'
import ImportanceGraph from 'components/ImportanceGraph'
import VarianceGraph from 'components/VarianceGraph'
import Transcript from './TranscriptV2'

const ResponsiveContainer = styled(Container)`
  margin: 0 auto;
`

const Page = styled.div`
  display: grid;
  margin-top: ${spacer(4)};
  margin-bottom: ${spacer(4)};
  grid-column-gap: ${spacer(6)};
  grid-row-gap: ${spacer(4)};
  grid-template-columns: 1fr 400px;
  grid-template-areas:
    'title title'
    'player highlights'
    'graphs highlights'
    'transcript highlights';

  ${mediaDn('lg')} {
    grid-template-columns: 1fr;
    grid-template-areas:
      'title'
      'player'
      'graphs'
      'highlights'
      'transcript';
  }
`

const Title = styled.div`
  grid-area: title;
  display: flex;
  align-items: center;
  ${typography('headline1')};
  ${fontWeight('bold')};
`

const Player = styled.div`
  grid-area: player;
  top: 0;
`

const Highlights = styled.div`
  grid-area: highlights;
`

const TranscriptContainer = styled.div`
  grid-area: transcript;
`
const Graphs = styled.div`
  grid-area: graphs;
`

class VideoPlayerContainer extends Component {
  state = {
    duration: 0,
    currentTime: 0
  }

  videoPlayerRef = React.createRef()

  componentDidMount() {
    this.props.touchLastViewedAt()
  }

  updateDuration(duration) {
    this.setState({ duration })
  }

  seekToTime = time =>
    this.videoPlayerRef.current.setTime(time) ||
    this.videoPlayerRef.current.play()

  render() {
    const {
      clips,
      video,
      video: { feedback, url, title },
      show,

      items
    } = this.props
    const { duration } = this.state

    const clipsToShow = clips.filter(
      clip => clip.feedback == null || clip.feedback.positive
    )

    return (
      <TransitionGroup>
        <ResponsiveContainer>
          <Page>
            <Title>
              <FadeIn>{title}</FadeIn>
            </Title>
            <Player>
              <FadeIn>
                <VideoPlayer
                  onLoadedMetaData={() =>
                    !duration &&
                    this.updateDuration(this.videoPlayerRef.current.duration())
                  }
                  onTimeUpdate={() =>
                    this.videoPlayerRef.current &&
                    this.videoPlayerRef.current.currentTime() !==
                      this.state.currentTime &&
                    this.setState({
                      currentTime: this.videoPlayerRef.current.currentTime()
                    })
                  }
                  ref={this.videoPlayerRef}
                  sources={[{ src: url, type: 'video/mp4' }]}
                  plugins={{
                    clipPlugin: {
                      clips: clipsToShow,
                      onClipsEnded: () => feedback || show()
                    }
                  }}
                />
              </FadeIn>
            </Player>

            <Graphs>
              <ImportanceGraph
                video={video}
                duration={duration}
                currentTime={this.state.currentTime}
              />
              <VarianceGraph video={video} duration={duration} />
            </Graphs>
            <TranscriptContainer>
              <FadeIn>
                <Transcript
                  items={items}
                  currentTime={this.state.currentTime}
                  clipsToShow={clipsToShow}
                  seekToTime={time => this.seekToTime(time)}
                />
              </FadeIn>
            </TranscriptContainer>

            <Highlights>
              <ClipsContainer
                currentTime={this.state.currentTime}
                clips={clips}
                clipsToShow={clipsToShow}
                seekToTime={time => this.seekToTime(time)}
                duration={duration}
              />
            </Highlights>
          </Page>
        </ResponsiveContainer>
      </TransitionGroup>
    )
  }
}

export default VideoPlayerContainer



// WEBPACK FOOTER //
// ./src/routes/video/components/VideoPlayerContainerV2.js